export const ORIGINAL_STATUS_TRANSITION_ID = '__original_status_transition_id__' as const;
export const ORIGINAL_STATUS_TRANSITION = {
	id: ORIGINAL_STATUS_TRANSITION_ID,
	name: '__original_status_transition_name__',
};
